import ItemNames from "../../../mixins/item-name-list-search";

Vue.component("checklist-sets", {

    mixins: [ItemNames],

    props: ["checklistSets"],

    data () {
        return {
            checklists: this.checklistSets,
            selectedChecklist: null,
            selectedChecklistItem: null,
            checklistCreateForm: new AppForm({}),
            checklistEditForm: new AppForm({}),
            checklistItemCreateForm: new AppForm({}),
            checklistItemEditForm: new AppForm({}),
            editingChecklistId: null,
        };
    },

    mounted () {
        if (this.checklists && this.checklists.length > 0) {
            this.showChecklist(this.checklists[0]);
        }
    },

    methods: {
        enableEditing (checklist) {
            this.showChecklist(checklist);
            this.editingChecklistId = checklist.id;
        },

        showChecklist (checklist) {
            if (this.selectedChecklist?.id !== checklist.id) {
                this.editingChecklistId = null;
            }
            this.selectedChecklist = checklist;
            this.checklistEditForm = new AppForm(this.selectedChecklist);
            $("[data-toggle=\"tooltip\"]").tooltip();
        },

        showChecklistCreateForm () {
            $("#modal-checklist-create-form").modal("show");
        },

        hideChecklistCreateForm () {
            $("#modal-checklist-create-form").modal("hide");
            this.checklistCreateForm = new AppForm({});
        },

        showChecklistItemCreateForm () {
            $("#modal-checklist-item-create-form").modal("show");
        },

        hideChecklistItemCreateForm () {
            $("#modal-checklist-item-create-form").modal("hide");
            this.checklistItemCreateForm = new AppForm({});
        },

        showChecklistItemEditForm (item) {
            this.selectedChecklistItem = item;
            this.checklistItemEditForm = new AppForm(this.selectedChecklistItem);
            $("#modal-checklist-item-edit-form").modal("show");
        },

        createChecklist () {

            App.post("/settings/inspections/checklists/create", this.checklistCreateForm)
            .then(response => {
                this.checklists.unshift(response);
                this.hideChecklistCreateForm();
                this.showChecklist(response);
                Bus.$emit("checklist-created");
            })
            .catch(errors => {
                toastr.error("Error creating checklist");
            });
        },

        updateChecklist (checklist) {
            App.patch("/settings/inspections/checklists/" + checklist.id + "/update", this.checklistEditForm)
            .then(response => {
                const index = this.checklists.findIndex(c => c.id === response.id);
                if (index !== -1) {
                    Vue.set(this.checklists, index, response);
                }

                this.editingChecklistId = null;
                this.selectedChecklist = response;

                toastr.success("Checklist updated!");
                this.showChecklist(response);
            })
            .catch(errors => {
                toastr.error("Error updating checklist");
            });
        },

        showChecklistDeleteConfirmation (checklist) {
            swal({
                title: "Delete " + checklist.name,
                text: "Are you sure you want to delete this checklist?",
                showCancelButton: true,
            }).then((result) => {
                if (result.value) {
                    this.deleteChecklist(checklist);
                }
            });
        },

        //Used to clear error message once user begins editing input, checks first if an
        //error exists
        clearError () {
            if (this.checklistEditForm.errors.has("name")) {
                this.checklistEditForm.errors.forget("name");
            }
        },

        deleteChecklist (checklist) {
            axios.post("/settings/inspections/checklists/" + checklist.id + "/delete", {_method: "DELETE"})
            .then(response => {
                this.removeDeletedChecklist(checklist);
                toastr.success("Checklist deleted!");
            })
            .catch(errors => {
                toastr.error("Checklist could not be deleted!");
            });
        },

        removeDeletedChecklist (checklist) {
            const index = this.checklists.indexOf(checklist);

            if (index !== -1) {
                this.checklists.splice(index, 1);
            }

            if (this.selectedChecklist === checklist) {
                this.selectedChecklist = null;
            }
        },

        createChecklistItem () {
            App.post("/settings/inspections/checklists/" + this.selectedChecklist.id + "/items/create", this.checklistItemCreateForm)
            .then(response => {
                this.selectedChecklist.items.push(response);
                this.setItemsSequenceFromIndex();
                this.hideChecklistItemCreateForm();
            })
            .catch(errors => {
                toastr.error("Error creating checklist item!");
            });
        },

        updateChecklistItem () {
            App.patch("/settings/inspections/checklists/items/" + this.selectedChecklistItem.id + "/update", this.checklistItemEditForm)
            .then(response => {
                toastr.success("Item saved!");
                const index = this.selectedChecklist.items.findIndex(i => i.id === response.id);

                if (index !== -1) {
                    Vue.set(this.selectedChecklist.items, index, response);
                }

                $("#modal-checklist-item-edit-form").modal("hide");
            })
            .catch(errors => {
                toastr.error("Error updating item");
            });
        },

        removeChecklistItem (item) {
            let self = this;
            swal({
                title: "Delete " + item.name,
                text: "Are you sure you want to delete this checklist item?",
                showCancelButton: true,
            }).then((result) => {
                if (result.value) {
                    axios.post("/settings/inspections/checklists/items/" + item.id + "/delete", {_method: "DELETE"})
                    .then(response => {
                        const index = self.selectedChecklist.items.indexOf(item);

                        if (index !== -1) {
                            self.selectedChecklist.items.splice(index, 1);
                            self.setItemsSequenceFromIndex();
                        }
                    })
                    .catch(errors => {
                        toastr.error("Error deleting item!");
                    });
                }
            });
        },

        setItemsSequenceFromIndex () {
            this.selectedChecklist.items.map((item, index) => {
                item.sequence_number = index + 1;
            });
        },

        updateChecklistItemSequence () {
            this.setItemsSequenceFromIndex();

            var updatedItems = this.selectedChecklist.items.map(item => {
                return {"id": item.id, "sequence_number": item.sequence_number};
            });

            axios.post("/settings/inspections/checklists/" + this.selectedChecklist.id + "/items/order", {
                _method: "PATCH",
                "updatedItems": updatedItems
            }).then(response => {

            }).catch(errors => {
                toastr.error("Error reordering checklist.");
            });
        },
    },
});
